import { render, staticRenderFns } from "./ChangeStage.vue?vue&type=template&id=8b364720&scoped=true"
import script from "./ChangeStage.vue?vue&type=script&lang=js"
export * from "./ChangeStage.vue?vue&type=script&lang=js"
import style0 from "./ChangeStage.vue?vue&type=style&index=0&id=8b364720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b364720",
  null
  
)

export default component.exports